import sanityClient from "@sanity/client";
import imageUrlBuilder from "@sanity/image-url";

export const client = sanityClient({
  projectId: process.env.REACT_APP_SANITY_PROJECT_ID,
  // projectId: "k2oher3v",
  dataset: "production",
  apiVersion: "2022-02-01",
  useCdn: "true",
  token: process.env.REACT_APP_SANITY_TOKEN,
  // token:
  // "sk4RHTwUqeYI1BodBdADE51NKeg6EWWSfIlMTfbxGKqppFxYsGvhqEQNm5vGqYDDrAl1CwTmVylx5cejpF6ZIMg6BptjeTR3RP5Jp5ut8RdxIqrmeCnfUOSyDP3sf2XQOlMvvEvGc0xNNvfLfKqETu0yFSJlIIo0eBJbRwvQk3QMAXm7Gz2Z",
});

const Builder = imageUrlBuilder(client);

export const urlFor = (source) => Builder.image(source);
